import React from "react";
import { useEffect, useState } from "react";
import { Navigate, Route, useLocation } from "react-router-dom";

import { Outlet } from "react-router-dom";
import MetaMaskService from "../Common/metamaskService.jsx";

const ProtectedRoute = ({ component: Component, path, ...rest }) => {
  const [isConnected, setIsConnected] = useState(null);

  useEffect(() => {
    new MetaMaskService().isMetaMaskConnected().then((connected) => {
      let account = localStorage.getItem("accountId");
      setIsConnected(connected && account);
    });
  });

  if (isConnected === null) {
    return <></>;
  }

  //let location = useLocation();
  if (isConnected) {
    return <Outlet />;
  } else {
    return (
      <Navigate
        to={{
          pathname: "/login",
          // state: { from: location },
        }}
      />
    );
  }
};

export default ProtectedRoute;
